import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'evento-item',
  templateUrl: './evento-item.component.html',
  styleUrls: ['./evento-item.component.scss']
})
export class EventoItemComponent implements OnInit{
  
  @Input("data") data:any = null;

  constructor(
    public router: Router
  ){}

  /**
   * 
   * To route
   * 
   */
  toRoute(){

    this.router.navigateByUrl("/eventos/"+this.data.apelido);

  }
  /**
   * 
   * Init
   * 
   */
  ngOnInit():void{
    
  }

}
